var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var defaultMaskExpansion = 101.6; // 4 Mil TODO: should this also be stored in fab settings?

var ThermalConnectionTypes = require("./../thermalConnectionTypes.js");

var AbstractPadstackData = function (topCopper, maskEnable, maskOverride, maskExpansion, connectionType) {
    var self = this;

    this.makeObservableTreeNode();

    this.topCopper = this.value("topCopper", true);
    this.maskEnable = this.value("maskEnable", true);
    this.maskOverride = this.value("maskOverride", true);
    this.maskExpansion = this.value("maskExpansion", true);
    this.connectionType = this.value("connectionType", true);

    this.topSolderMask = this.cachedFunction("topSolderMask",
        function () {
            return self.getSolderMask();
        },
        [[this.topCopper, this.topCopper.onBubble], this.maskEnable, this.maskOverride, this.maskExpansion]
    );

    this.thermalCutout = this.cachedFunction("thermalCutout",
        function (spokeWidth, airGapWidth, nConductor, angle, minSpokeWidth, minExpansion) {
            if(this.connectionType() === ThermalConnectionTypes.RELIEF) {
                var shape = self.topCopper().clone().segmentedGeometry();
                var expanded = shape.buffer(airGapWidth);

                var bb = shape.getBB();

                var dir = new lib_geometry.Coord(1,0);
                dir = dir.rotate(angle);
                var height = (bb.height+2*spokeWidth+minSpokeWidth)/4;
                if (height < minSpokeWidth) height = minSpokeWidth + 4;
                var horSeg = new lib_geometry.Segment(dir.mult(-1000000), dir.mult(1000000));
                var hor = horSeg.toPolygon(height/2, 1);

                var dir = new lib_geometry.Coord(0,1);
                dir = dir.rotate(angle);

                var width = (bb.width+2*spokeWidth+minSpokeWidth)/4;
                if (width < minSpokeWidth) width = minSpokeWidth + 4;
                var verSeg = new lib_geometry.Segment(dir.mult(-1000000), dir.mult(1000000));
                var ver = verSeg.toPolygon(width/2, 1);

                return new lib_geometry.MultiPolygon(lib_geometry.Union([expanded], [hor, ver, shape]));
            } else if(this.connectionType() === ThermalConnectionTypes.DIRECT) {
                var shape = self.topCopper().clone().segmentedGeometry();
                var expanded = shape.buffer(airGapWidth);
                return expanded;
            } else {
                return null;
            }
        },
        [this.topCopper,  this.connectionType]
    );

    if(topCopper != undefined) this.topCopper(topCopper);
    if(maskEnable != undefined) this.maskEnable(maskEnable);
    if(maskOverride != undefined) this.maskOverride(maskOverride);
    if(maskExpansion != undefined) this.maskExpansion(maskExpansion);
    if(connectionType != undefined) this.connectionType(connectionType);
};
lib_core.mixin(AbstractPadstackData, lib_core.ObservableTreeNode);

module.exports = AbstractPadstackData;

AbstractPadstackData.prototype.getSolderMask = function() {
    if(this.maskEnable()) {
        var shape = this.topCopper().clone();
        var expansion = this.maskOverride() ? this.maskExpansion() : defaultMaskExpansion;
        shape.width(shape.width()+expansion);
        shape.height(shape.height()+expansion);
        if(shape.rx) shape.rx(shape.rx()+expansion/2);
        if(shape.ry) shape.ry(shape.ry()+expansion/2);
        return shape;
    } else {
        return null;
    }
};